import React, { useEffect } from "react";
import { useTheme, withStyles } from "@material-ui/core/styles";
import "fontsource-muli";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../components/CustomText";
import CustomModal from "../../components/CustomModal";
import Color from "../../../utils/Color";
import Grid from "@material-ui/core/Grid";
import useMediaQuery from "@material-ui/core/useMediaQuery";



const AuthorizationMaybankRedirect = ({
  classes,
  isVisible,
  handleClose,
  redirectUrl,
  authoDataMsg,
  ...props
}) => {
  const theme = useTheme();
  const matchesXS = useMediaQuery(theme.breakpoints.down("xs"));
  const matchesMD = useMediaQuery(theme.breakpoints.down("md"));
  const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));

  const [customToastStatus, setCustomToastStatus] = React.useState(false);
  const [toastMessage, setToastMessage] = React.useState("");

  const [open, setOpen] = React.useState(false);

  const onClickNextButton = () => {
    if(authoDataMsg === "Authorization failed. Please try again later or contact Customer Service"){
        window.location.href = redirectUrl;
    }else{
        window.location.href = redirectUrl;
    }
   
  };

  const modalContainer = () => {
    return (
      <div className={classes.containerStyle}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className={classes.tooltipContainer}>
              <CustomText design={classes.titleTextStyle}>
                {authoDataMsg}
              </CustomText>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };

  return (
    <div>
      <CustomModal
        open={isVisible}
        handleClose={handleClose}
        titlestyle={classes.modalTitleStyle}
        modalDesign={classes.modalDesign}
        submitButtonText={"Ok"}
        //cancelButtonText={"Cancel"}
        modalComponent={modalContainer()}
        disableBackdropClick
        handleSubmitButton={() => onClickNextButton()}
        handleCancelButton={handleClose}
      />
    </div>
  );
};

const styles = (theme) => ({
  containerStyle: {
    flexGrow: 1,
    marginBottom: 30,
    paddingRight: 20,
  },
  modalTitleStyle: {
    ...getFontSize("large"),
  },
  titleTextStyle: {
    ...getFontSize("large"),
    ...getFontWeight("bold"),
  },
  modalDesign: {
    [theme.breakpoints.down("xs")]: {
      minWidth: 300,
      marginTop: 20,
      marginBottom: 20,
    },
    [theme.breakpoints.up("sm")]: {
      minWidth: 580,
    },
    [theme.breakpoints.up("lg")]: {
      minWidth: 700,
      maxWidth: 700,
    },
    textInputStyle: {
      height: 35,
      marginLeft: 5,
      marginRight: 5,
    },
  },
  tooltipContainer: {
    display: "flex",
    alignItems: "center",
  },
  infoIconStyle: {
    width: "17px",
    height: "17px",
    alignSelf: "center",
    color: Color.secondaryTextColor,
    marginLeft: 10,
  },
  tooltipTextStyle: {
    color: Color.secondaryTextColor,
    ...getFontWeight("normal"),
  },
  highLightedDescTextStyle: {
    ...getFontWeight("bold"),
  },
  textInputContainer: {
    height: 40,
    marginLeft: 10,
  },
  dividerStyle: {
    marginTop: 20,
    marginBottom: 20,
  },
  paymentInputContainer: {
    height: 40,
    [theme.breakpoints.only("xs")]: {
      width: 150,
    },
    width: 300,
  },
  paymentInputTitleTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("small"),
    color: Color.primaryTextColor,
  },
  accountNumberTitleTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("small"),
    marginBottom: 0,
    color: Color.primaryTextColor,
  },
});

export default withStyles(styles, { withTheme: true })(
  AuthorizationMaybankRedirect
);
